<footer class="main-footer" style="text-align: center;background-color:#f4f6f9;border-top: 0">
    <strong>Copyright &copy; 2024 <a target="_blank" href="http://cfd.com.tw/">CFD</a></strong>
</footer>
